import { today } from "@repo/helpers";
import { KeyedArray } from "@repo/models";
import { EditableGridPage, Loading } from "@repo/ui";
import { FC, useEffect } from "react";

import { useLocationQueries } from "../../api/locationApi";
import { useLocationContext, useStatusHistoryContext } from "../../contexts/editableItemContext";
import { StatusHistoryProvider } from "../../contexts/editableItemContext";
import { LocationStatus } from "../../models";
import { StatusHistoryEditor } from "./editor";
import { StatusHistoriesGrid } from "./grid";
import style from "./style.module.scss";

export const StatusHistory: FC = () => {
	return (
		<StatusHistoryProvider>
			<section>
				<EditStatusHistories />
			</section>
		</StatusHistoryProvider>
	);
};

function EditStatusHistories() {
	const { locationId, location } = useLocationContext();
	const { item, overwriteItem, pendingChanges } = useStatusHistoryContext();
	const { useStatusHistoriesQuery } = useLocationQueries();
	const { data: statusHistories, loading } = useStatusHistoriesQuery(locationId);

	// EditableGridPage only calls these, so they aren't memoized
	const handleOpen = (item: LocationStatus) => {
		if (item?.id === location.statusHistory.id) overwriteItem({ ...item, canEdit: true, canEditStatus: false });
		else overwriteItem({ ...item, canEdit: false, canEditStatus: false });
	};

	const newItem = () => {
		overwriteItem({
			startDate: today(),
			endDate: null,
			canEdit: true,
			canEditStatus: true,
		} as LocationStatus);
	};

	useEffect(() => {
		if (item?.statusId != null) return;
		if (statusHistories?.length > 0) handleOpen(statusHistories[0]);
	}, [statusHistories]);

	const keyedStatusHistories = new KeyedArray<LocationStatus>(statusHistories, (i) => i.id);

	return (
		<Loading loading={loading}>
			<EditableGridPage<LocationStatus>
				id="LocationStatusContainer"
				items={keyedStatusHistories}
				keyProperty="id"
				Editor={StatusHistoryEditor}
				Grid={StatusHistoriesGrid}
				openItem={handleOpen}
				pendingChanges={pendingChanges}
				newItem={newItem}
				newItemText="Add Status History"
				itemsLoaded={loading}
				entityId={item?.id}
				updateRoute={updateRoute}
				gridContainerClassName={style.gridPageContainer}
			/>
		</Loading>
	);
}

/** The portal keeps the selected status history in context, not the URL */
function updateRoute() {}
